import dayjs from 'dayjs';

export const validateDate = (value, isRequired, minDate = null, maxDate = null) => {

    const formatDate = ({ date, format = 'YYYY-MM-DD', strict = false } = {}) => {
        const dayJsDate = dayjs(date);
        if (!dayJsDate.isValid() && strict) throw new Error();
        return dayJsDate.format(format);
    }

    const dateIsValid = (date) => dayjs(date).isValid();

    if (!value && !isRequired) return true;

    try {

        const date = formatDate({ date: value, strict: true });

        const minDateParsed = minDate && dateIsValid(minDate) ? { value: formatDate({ date: minDate }), label: formatDate({ date: minDate, format: 'MM/DD/YYYY' }) } : null;
        const maxDateParsed = maxDate && dateIsValid(maxDate) ? { value: formatDate({ date: maxDate }), label: formatDate({ date: maxDate, format: 'MM/DD/YYYY' }) } : null;

        if (minDateParsed && date < minDateParsed.value) {
            return `Date must be on or after ${minDateParsed.label}`;
        }

        if (maxDateParsed && date > maxDateParsed.value) {
            return `Date must be on or before ${maxDateParsed.label}`;
        }

        return true;
    } catch (ex) {
        return 'Please enter a valid date';
    }
};

